import React, { useState } from "react";

const useLoading = () => {
  const [loading, setLoading] = useState(false);
  return [loading, () => setLoading(true), () => setLoading(false)] as const;
};

export default useLoading;
